<template>
  <div class="animated fadeIn">
    <div class="row mb-20">
      <div class="col-6">
        <a @click="openPage('/ptSessionBuy')" class="btn-grey">
          <i class="fas fa-arrow-circle-left mr-5"></i>Back
        </a>
      </div>
    </div>
    <div class="box">
      <div class="p-20">
        <form data-vv-scope="ptSession">
          <div class="row justify-content-center mt-30">
            <div class="col-sm-6">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="addData.branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Member ID</label>
                </b-col>
                <b-col sm="9">
                  <div class="custom-search-select">
                    <model-select autocomplete="false" @searchchange="searchMemberWithoutBranch"
                      :options="optionsMember" class="border-bottom" name="member_id" v-validate="'required'"
                      v-model="addData.member_id"></model-select>
                  </div>
                  <span class="error">{{ errors.first('ptSession.member_id') }}</span>
                </b-col>
              </b-row>
              <b-row v-if="countAvailForNewMember != 1" class="mb-20">
                <b-col sm="3">
                  <label>Add New Member</label>
                </b-col>
                <b-col sm="9">
                  <div class="custom-search-select">
                    <multi-select :options="optionsMemberNew" :selected-options="items" @searchchange="searchMemberNew"
                      placeholder="Select member" name="new_member_id" @select="onSelect">
                    </multi-select>
                  </div>
                  <span class="error">Max {{ countAvailForNewMember }} member.</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Member Name</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom bg-transparent" disabled v-model="fullNameDetail"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Phone Number</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.phone_number"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Email</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.email"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Membership Type</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom bg-transparent" disabled
                    v-model="detailMember.membership_last_buy_name" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Join Date</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom bg-transparent" disabled v-model="detailMember.start_membership"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Employee ID</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select @change="getCSData" class="border-bottom" name="customer_service_id"
                    v-validate="'required'" v-model="addData.customer_service_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataCS" :key="item.id" :value="item.id">
                      <template v-if="item.branch">{{ item.branch.codename }}</template>
                      <template v-else>XX</template>
                      -{{ item.id }}
                    </option>
                  </b-form-select>
                  <span class="error">{{ errors.first('ptSession.customer_service_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Customer Service Name</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom bg-transparent" disabled v-model="CSName"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Detox</label>
                </b-col>
                <b-col sm="9">
                  <input type="checkbox" id="agreeFormDetox" name="checkbox_agree_detox"
                        v-model="addData.is_detox" value />
                </b-col>
              </b-row>
            </div>
            <div class="col-sm-6">
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Seller</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select class="border-bottom" name="seller" v-validate="'required'" v-model="addData.sales_id">
                    <option :value="null">Please select</option>
                    <option :value="0">Personal Trainer</option>
                    <option v-for="item in itemSales" :key="item.id" :value="item.id">Sales - {{ item.fullname }}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('ptSession.seller') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Personal Trainer</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select @change="filterPtSession" class="border-bottom" name="personal_trainer"
                    v-validate="'required'" v-model="addData.personal_trainer_id">
                    <option :value="null">Please select</option>
                    <option v-for="listItem in itemPt" :key="listItem.id" :value="listItem.id">{{ listItem.name }}
                    </option>
                  </b-form-select>
                  <span class="error">{{ errors.first('ptSession.personal_trainer') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>PT Session</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select @change="getPtSessionData" class="border-bottom" name="pt_session"
                    v-validate="'required'" v-model="addData.pt_session_id">
                    <option :value="null">Please select</option>
                    <option v-for="itemSession in itemPtSession" :key="itemSession.id" :value="itemSession.id">
                      {{ itemSession.name }}
                    </option>
                  </b-form-select>
                  <span class="error">{{ errors.first('ptSession.pt_session') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label for="address">Is PTService</label>
                </b-col>
                <b-col sm="9">
                  <toggle-button v-model="is_pt_service" name="is_pt_service" :sync="true" />
                  <span class="error">{{ errors.first('is_pt_service') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>PT Session Quantity</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input class="border-bottom bg-transparent" disabled v-model="detailPtSession.quantity"
                    type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>PT Session Price</label>
                </b-col>
                <b-col sm="9">
                  <money class="form-control border-bottom bg-transparent" v-model="detailPtSession.price"
                    v-bind="money2" disabled>
                  </money>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Gross Amount</label>
                </b-col>
                <b-col sm="9">
                  <money class="form-control border-bottom bg-transparent" v-model="addData.gross_amount"
                    :value="totalPayment" v-bind="money2" disabled></money>
                </b-col>
              </b-row>
              <hr>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Voucher</label>
                </b-col>
                <b-col sm="9">
                  <div class="custom-search-select">
                    <model-select autocomplete="false" @input="onVoucherChange" :options="itemVouchers"
                      class="border-bottom" name="vouchers" v-model="addData.voucher_id"></model-select>
                  </div>
                  <span class="error">{{ errors.first('ptSession.member_id') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20" v-if="addData.voucher_no">
                <b-col sm="3">
                  <label>Voucher Amount</label>
                </b-col>
                <b-col sm="9">
                  <money class="form-control border-bottom bg-transparent" v-model="addData.voucher_amount"
                    v-bind="money2" :value="redeemVoucher" disabled></money>
                </b-col>
              </b-row>
              <hr>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>Payment Type</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select class="border-bottom" name="session_payment_type_id"
                    v-model="addData.session_payment_type_id"
                    @change="addData.installment_month = (addData.session_payment_type_id == 1) ? '' : addData.installment_month">
                    <option value="1">Regular</option>
                    <option value="2">Installment</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20" v-if="addData.session_payment_type_id == '2'">
                <b-col sm="3">
                  <label>Installment Month</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select class="border-bottom" name="installment_month" v-validate="'required'"
                    v-model="addData.installment_month">
                    <option value="3">3</option>
                    <option value="6">6</option>
                    <option value="12">12</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('ptSession.installment_month') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="3">
                  <label>PT Session Category</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select class="border-bottom" name="session_contract_category_id"
                    v-model="addData.session_contract_category_id">
                    <option value="1">New</option>
                    <option value="2">Renew</option>
                  </b-form-select>
                </b-col>
              </b-row>
            </div>
          </div>
          <hr>
          <div class="mb-10">
            <div class="row">
              <div class="col-lg-6">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <label>Member Point</label>
                  </b-col>
                  <b-col sm="9">
                    <money class="form-control border-bottom bg-transparent" v-model="memberPoint" v-bind="money2"
                      disabled>
                    </money>
                  </b-col>
                </b-row>
                <b-row class="mb-20" v-if="memberPoint > 0">
                  <b-col sm="3">
                    <label>Redeem Amount</label>
                  </b-col>
                  <b-col sm="9">
                    <money class="form-control border-bottom bg-transparent" v-model="redeemAmount"
                      :value="redeemPayment" v-bind="money2"></money>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
          <hr>
          <div class="mb-10">
            <div>Payment Methods</div>
            <hr class="short-line left mb-20" />
            <div class="row">
              <div class="col-lg-7">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div>Payment 1</div>
                  </b-col>
                  <b-col sm="9">
                    <div class="mb-20">
                      <b-form-select v-validate="'required'" @change="changePaymentType1" name="payment_type_id_1"
                        v-model="addData.payment_type_id_1" class="form-control border-bottom">
                        <option :value="null" selected>Please select</option>
                        <option v-for="item in itemsPaymentType" :key="item.id" :value="item.id">{{ item.name }}</option>
                      </b-form-select>
                      <span class="error">{{ errors.first('ptSession.payment_type_id_1') }}</span>
                    </div>
                    <div class="mb-10">
                      <b-form-radio-group class="radio-custom-list" @change="changePaymentCard1"
                        :disabled="[1, 6, 9].includes(addData.payment_type_id_1)" name="paymentCard1"
                        v-model="addData.payment_card_id_1">
                        <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id"
                          :value="item.id">{{ item.name }}</b-form-radio>
                      </b-form-radio-group>
                      <div
                        v-if="![1, 9].includes(addData.payment_type_id_1) && addData.payment_type_id_1 != null && addData.payment_card_id_1 == null">
                        <span class="error">The payment_card_id_1 field is required.</span>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="col-lg-5">
                <money class="form-control border-bottom custom-currency w-100" id="paymentFirstAmount"
                  v-model="amountPaymentCard1" v-bind="money2"></money>
                <div v-if="amountPaymentCard1 == '' || amountPaymentCard1 == null">
                  <span class="error">The payment first amount field is required.</span>
                </div>
                <!-- <span :ref="'error-print'" class="error hidden">{{ errorMoney }}</span> -->
              </div>
            </div>
            <div class="row">
              <div class="col-lg-7">
                <b-row class="mb-20">
                  <b-col sm="3">
                    <div>Payment 2</div>
                  </b-col>
                  <b-col sm="9">
                    <div class="mb-20">
                      <b-form-select name="payment_type_id_2" @change="changePaymentType2"
                        v-model="addData.payment_type_id_2" class="form-control border-bottom">
                        <option :value="null" selected>Please select</option>
                        <option v-for="item in itemsPaymentType2" :key="item.id" :value="item.id">{{ item.name }}</option>
                      </b-form-select>
                    </div>
                    <div class="mb-10">
                      <b-form-radio-group class="radio-custom-list" @change="changePaymentCard2"
                        :disabled="addData.payment_type_id_2 == 1 || addData.payment_type_id_2 == 6" name="paymentCard2"
                        v-model="addData.payment_card_id_2">
                        <b-form-radio class="font-13" v-for="item in itemsPaymentCard" :key="item.id"
                          :value="item.id">{{ item.name }}</b-form-radio>
                      </b-form-radio-group>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div class="col-lg-5">
                <money class="form-control border-bottom custom-currency w-100" v-model="amountPaymentCard2"
                  :value="paymentLeft" v-bind="money2"></money>
              </div>
            </div>
            <div class="row">
              <b-col sm="2">
                <div>Notes</div>
              </b-col>
              <b-col sm="10">
                <textarea class="w-100" rows="5" v-model="addData.notes"></textarea>
              </b-col>
            </div>
          </div>
          <div class="text-right">
            <button @click.prevent="getDocument('ptSession')" class="btn-primary">Submit</button>
          </div>
        </form>
        <b-modal modal-class="modal-custom-form" hide-footer v-model="modalShow" centered title="Checkout">
          <div class="container-iframe mobile-responsive">
            <iframe id="privyFrame" v-show="urlDoc" :srcdoc="urlDoc" class="w-100" frameborder="0"></iframe>
            <div class="p-20 bg-white">
              <div class="row justify-content-center">
                <div class="col-md-6">
                  <div class="checkbox-part text-center">
                    <form data-vv-scope="submit-form">
                      <input type="checkbox" v-validate="'required'" id="agreeForm" name="checkbox_agree"
                        v-model="checked" value />
                      <label for="agreeForm" class="font-13 font-300 ml-10 label-agree">Click here to indicate that you
                        have
                        read and agree to the terms presented in the Terms and Conditions agreement</label>
                      <div class="text-center mt-10 mb-5">
                        <span class="error color-red">{{ errors.first('submit-form.checkbox_agree') }}</span>
                      </div>
                    </form>
                  </div>
                  <div class="d-flex justify-content-center">
                    <button type="submit" @click.prevent="validatePtSessionTick('submit-form')"
                      class="btn-primary text-center mt-10">Submit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
        <div v-if="loadingActive == true" class="loading-container">
          <div class="wrap-screen w-100 h-100">
            <img :src="`/svg-loaders/oval.svg`" width="60" alt />
            <div class="title-loading color-white">Loading...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import { ModelSelect } from "vue-search-select";
import { MultiSelect } from 'vue-search-select'
import Mixin from '../../mixins/memberMixin'
export default {
  name: "addbranch",
  components: {
    ModelSelect,
    MultiSelect
  },
  mixins: [Mixin],
  data: function () {
    return {
      loadingActive: false,
      errorMoney: "The amount field is required!",
      dataMember: [],
      dataBranch: [],
      dataCS: [],
      config: {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d"
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false
      },
      money2: {
        decimal: ",",
        thousands: ".",
        prefix: "IDR ",
        suffix: "",
        precision: 2,
        masked: false
      },
      is_pt_service: false,
      memberPoint: 0,
      redeemAmount: 0,
      optionsMember: [{ value: null, text: "Please select" }],
      optionsMemberNew: [{ value: null, text: "Please select" }],
      optionAddNewMember: [],
      countAvailForNewMember: 1, // if qty > 1 then show new member
      searchText: '', // If value is falsy, reset searchText & searchItem
      items: [],
      itemVouchers: [],
      itemVouchers2: [],
      tempGrossAmount: 0,
      lastSelectItem: {},
      itemSales: [],
      itemPt: [],
      itemPtSession: [],
      itemsPaymentCard: [],
      itemsPaymentType: [],
      itemsPaymentType2: [],
      detailMember: {},
      detailPtSession: {},
      detailCS: {},
      fullName: "",
      modalShow: false,
      CSName: "",
      // modalShow: false,
      linkPrivyId: "",
      amountPaymentCard1: "",
      amountPaymentCard2: "",
      addData: {
        branch_id: null,
        customer_service_id: null,
        member_id: null,
        new_member_id: [],
        sales_id: null,
        personal_trainer_id: null,
        gross_amount: "",
        transaction_type_id: 5,
        pt_session_id: null,
        payment_type_id_1: null,
        payment_card_id_1: null,
        payment_amount_1: "",
        payment_type_id_2: null,
        payment_card_id_2: null,
        payment_amount_2: "",
        session_payment_type_id: "1",
        installment_month: "0",
        session_contract_category_id: "1",
        member_voucher_id: null,
        voucher_id: null,
        voucher_no: null,
        voucher_amount: 0,
        redeem_amount: 0,
        is_pt_service: 0,
        is_detox: false
      },
      addDataPrivy: {
        member_id: null,
        customer_id: null,
        branch_id: null,
        trx_id: "",
        doc_name: "personal_trainer.hbs"
      },
      fullNameDetail: "",
      getTierData: "",
      linkDataPrivy: "",
      checked: false,
      checked2: false,
      dataAgree: {
        ticked_status: ""
      },
      dataGetUrlLead: {
        doc_name: "personal_trainer.hbs",
        trx_id: "",
        doc_type: 0 // 0 = personal trainer | 1 = detox
      },
      urlDoc: ""
    };
  },
  methods: {
    onRedeemChanged(value) {
      console.log(value)
      // if (value != 0) {
      //   this.addData.gross_amount = this.addData.gross_amount - value;
      // }
    },
    onVoucherChange(event) {
      const find = this.itemVouchers2.find((m) => m.voucher_id == event);
      if (find) {
        this.addData.voucher_amount = find.voucher_amount
        this.addData.voucher_no = find.voucher_no
        this.addData.member_voucher_id = find.id
      } else {
        this.addData.voucher_amount = 0
        this.addData.voucher_no = null
        this.addData.member_voucher_id = null
      }
    },
    onSelect(items, lastSelectItem) {

      if (this.items.length >= this.countAvailForNewMember) {
        this.items = []
        this.addData.new_member_id = []
        this.$toast.success("Max " + this.countAvailForNewMember + " for new member ", "Error", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });
      } else {
        this.items = items
        this.lastSelectItem = lastSelectItem
        var new_member_id = this.addData.new_member_id.find((e) => e == lastSelectItem.value)
        if (!new_member_id) {
          this.addData.new_member_id.push({ member_id: lastSelectItem.value })
        } else {
          var arr = this.addData.new_member_id.filter((e) => e != lastSelectItem.value)
          this.addData.new_member_id = arr
        }
      }

      console.log(this.addData.new_member_id);
    },
    // deselect option
    reset() {
      this.items = [] // reset
    },
    // select option from parent component
    selectFromParentComponent() {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual)
    },
    validatePtSessionTick(data1) {
      this.$validator.validateAll(data1).then(async result => {
        if (
          ![1, 9].includes(this.addData.payment_type_id_1) &&
          this.addData.payment_card_id_1 == null
        ) {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
          return;
        }
        if (result) {
          if (this.checked === true) {
            this.dataAgree.ticked_status = 1;
          } else {
            this.dataAgree.ticked_status = 0;
          }
          try {
            const agreeStatus = await axios.put(
              "transaction/v1/transaction/tick_form_agreement/" +
              this.dataGetUrlLead.trx_id,
              this.dataAgree
            );
            // console.log('Success submit tick',agreeStatus.data)
            this.$router.push("/ptSessionBuy");
            this.$toast.success("data saved successfully!", "Success", {
              position: "topCenter",
              icon: "icon-envelope",
              progressBarColor: "rgb(0, 255, 184)",
              theme: "dark",
              backgroundColor: "#565c70",
              messageColor: "#fff"
            });
          } catch (error) {
            console.log("error", error);
            this.$toast.success("cant saved data!", "Error", {
              position: "topCenter",
              icon: "icon-envelope",
              progressBarColor: "rgb(0, 255, 184)",
              theme: "dark",
              backgroundColor: "#565c70",
              messageColor: "#fff"
            });
          }
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
        }
      });
    },
    getDocument(event) {
      this.$validator.validateAll(event).then(result => {
        if (
          ![1, 9].includes(this.addData.payment_type_id_1) &&
          this.addData.payment_card_id_1 == null
        ) {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
          return;
        }
        if (result) {
          this.loadingActive = true;
          this.addData.payment_amount_1 = this.amountPaymentCard1;
          this.addData.payment_amount_2 = this.amountPaymentCard2;
          this.addData.redeem_amount = this.redeemAmount
          this.addData.is_pt_service = this.is_pt_service ? 1 : 0
          this.addData.is_detox = this.addData.is_detox ? 1 : 0

          // console.log(this.addData)

          // this.loadingActive = false;

          axios.post("transaction/v1/payment/save_pt_session/", this.addData)
            .then(response => {
              this.dataGetUrlLead.trx_id = response.data.data.id;
              this.dataGetUrlLead.doc_type = this.addData.is_detox
              if (this.addData.is_detox == 1) {
                this.dataGetUrlLead.doc_name = 'healing_detox.hbs';
              }
              axios
                .post(
                  "crm/v1/form_aggreement/html_generate/pt_session",
                  this.dataGetUrlLead
                )
                .then(response => {
                  // console.log('test', response)
                  this.urlDoc = response.data;
                  this.modalShow = true;
                  this.loadingActive = false;
                  this.$toast.success("data saved successfully!", "Success", {
                    position: "topCenter",
                    icon: "icon-envelope",
                    progressBarColor: "rgb(0, 255, 184)",
                    theme: "dark",
                    backgroundColor: "#565c70",
                    messageColor: "#fff"
                  });
                })
                .catch(error => {
                  // console.log('error', error)
                  this.loadingActive = false;
                  this.$toast.success("Error get data!", "Error", {
                    position: "topCenter",
                    icon: "icon-envelope",
                    progressBarColor: "rgb(0, 255, 184)",
                    theme: "dark",
                    backgroundColor: "#565c70",
                    messageColor: "#fff"
                  });
                });
            })
            .catch(error => {
              // console.log('error', error)
              this.loadingActive = false;
              this.$toast.success("Error get data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
        }
      });
    },
    filterPtSession(event) {
      if (event != null) {
        this.addData.pt_session_id = null;
        this.detailPtSession.quantity = 0;
        this.detailPtSession.price = 0;
        this.addData.gross_amount = 0;
        axios
          .get("fitness/v1/personal_training/" + event)
          .then(response => {
            // console.log(response.data.data.pt_tier)
            this.changeDataTier(response.data.data.pt_tier);
          })
          .catch(error => {
            console.log("error", error);
          });
      } else {
        this.addData.pt_session_id = null;
        this.detailPtSession.quantity = 0;
        this.detailPtSession.price = 0;
        this.addData.gross_amount = 0;
        this.changeDataTier("");
      }
    },
    changeDataTier(event) {
      axios
        .get(
          "fitness/v1/pt_session?pt_tier=" +
          event +
          "&sorting=name&sorting_type=asc"
        )
        .then(response => {
          this.itemPtSession = response.data.data.rows;
          // console.log('test', response)
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    getCSData(event) {
      axios
        .get("crm/v1/customer_service/" + event)
        .then(response => {
          this.detailCS = response.data.data;
          this.CSName = response.data.data.name;
          this.addDataPrivy.customer_id = response.data.data.id;
          // console.log('test', response)
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    async changePaymentCard1(event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType = payment_card.data.data.rows
    },
    async changePaymentCard2(event) {
      let payment_card = await axios.get('transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=' + event)
      this.itemsPaymentType2 = payment_card.data.data.rows
    },

    changePaymentType1(event) {
      if (event === 1) {
        this.addData.payment_card_id_1 = null;
      } else if (event === 6) {
        this.addData.payment_card_id_1 = 1;
      } else {
        this.addData.payment_card_id_1 = null;
      }
    },
    changePaymentType2(event) {
      if (event === 1) {
        this.addData.payment_card_id_2 = null;
      } else if (event === 6) {
        this.addData.payment_card_id_2 = 1;
      } else {
        this.addData.payment_card_id_2 = null;
      }
    },
    getMemberData(event) {
      axios
        .get("fitness/v1/member/" + event)
        .then(response => {
          this.detailMember = response.data.data;
          this.fullName =
            response.data.data.first_name + " " + response.data.data.last_name;
          this.addDataPrivy.branch_id = response.data.data.branch_id;
          this.addDataPrivy.member_id = response.data.data.id;
          // console.log('test', response)
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    getPtSessionData(event) {
      axios
        .get("fitness/v1/pt_session/" + event)
        .then(response => {
          this.items = []
          this.countAvailForNewMember = 1
          this.detailPtSession = response.data.data;
          this.addData.gross_amount =
            response.data.data.quantity * response.data.data.price;
          this.tempGrossAmount = this.addData.gross_amount

          if (response.data.data.group_member_qty != 1) {
            this.countAvailForNewMember = response.data.data.group_member_qty;
          }
          console.log('test', response.data.data.quantity)
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    formSelect(event) {
      return event;
    },
    changeValueMoney(event) {
      if (!(event.key === "")) {
        this.$refs["error-print"].classList.add("hidden");
      } else {
        this.$refs["error-print"].classList.remove("hidden");
      }
    },
    changeBranch(event) {
      this.getMemberWithoutBranch()

      axios.get('crm/v1/customer_service?branch_id=' + event).then(response => {
        this.dataCS = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      //seller
      axios.get('crm/v1/sales?status=active&sorting=fullname&sorting_type=asc&branch_id=' + event).then(response => {
        this.itemSales = response.data.data.rows;
      }).catch(error => {
        console.log('error', error)
      })

      //pt
      axios.get('fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc&branch_id=' + event).then(response => {
        this.itemPt = response.data.data.rows;
      }).catch(error => {
        console.log('error', error)
      })
    },
    openPage(event) {
      this.$router.push(event);
    },
    fetchData() {
      this.getMember()
      axios
        .get(
          "transaction/v1/payment_card?sorting=id&sorting_type=asc&status=active"
        )
        .then(response => {
          this.itemsPaymentCard = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      // voucher
      axios
        .get(
          "transaction/v1/member_voucher?page=1&limit=20&member_id=" + this.addData.member_id
        )
        .then(response => {
          this.itemVouchers2 = response.data.data.rows
          this.itemVouchers = [];
          this.itemVouchers.push({ value: null, text: "Please select" })
          for (let i = 0; i < response.data.data.rows.length; i++) {
            const el = response.data.data.rows[i];
            this.itemVouchers.push({ value: `${el.voucher_id}`, text: `${el.voucher_no} @Rp.${el.voucher_amount}` })
          }
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("transaction/v1/payment_type?sorting=id&sorting_type=asc&status=active&payment_card_id=1")
        .then(response => {
          this.itemsPaymentType = response.data.data.rows;
          this.itemsPaymentType2 = response.data.data.rows
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/sales?status=active&sorting=fullname&sorting_type=asc")
        .then(response => {
          this.itemSales = response.data.data.rows;
          // console.log('test', response)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get(
          "fitness/v1/personal_training?status=active&sorting=name&sorting_type=asc"
        )
        .then(response => {
          this.itemPt = response.data.data.rows;
          // console.log('test', response)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("fitness/v1/pt_session?sorting=name&sorting_type=asc")
        .then(response => {
          this.itemPtSession = response.data.data.rows;
          // console.log('test', response)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/customer_service?status=active")
        .then(response => {
          this.dataCS = response.data.data.rows;
          // console.log('test', response)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      // turn off autocomplete
      if (document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName("member_id");
        for (var i = 0; inputElements[i]; i++) {
          if (
            inputElements[i].className &&
            inputElements[i].className.indexOf("disableAutoComplete") != -1
          ) {
            inputElements[i].setAttribute("autocomplete", "off");
          }
        }
      }
    }
  },
  computed: {
    totalPayment: function () {
      let calculatedTotal = this.addData.gross_amount - this.addData.voucher_amount;
      this.amountPaymentCard1 = this.addData.gross_amount;
      return calculatedTotal;
    },
    paymentLeft: function () {
      if (
        String(this.amountPaymentCard1).length >
        String(this.addData.gross_amount).length
      ) {
        console.log("test");
        this.amountPaymentCard2 = 0;
      } else {
        this.amountPaymentCard2 =
          this.addData.gross_amount - this.amountPaymentCard1;
        this.amountPaymentCard2 = Math.abs(this.amountPaymentCard2);
      }
    },
    redeemPayment: function () {
      if (this.redeemAmount > this.memberPoint) {
        this.$toast.success("Not enough point", "Error", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });
        this.redeemAmount = 0;
        return this.redeemAmount
      } else {
        if (this.addData.gross_amount != 0) {
          this.addData.gross_amount = this.tempGrossAmount - this.redeemAmount - this.addData.voucher_amount;
        }
        return this.redeemAmount
      }
    },
    redeemVoucher: function () {
      return this.addData.voucher_amount
    },
    getMemberId: function () {
      return this.addData.member_id;
    }
  },
  watch: {
    getMemberId() {
      axios.get("mobile/v1/my_rewards/total_rewards?member_id=" + this.addData.member_id)
        .then(response => {
          this.memberPoint = response.data.data[0].total_amount
        })
        .catch(error => {
          console.log("error", error);
        });

      axios
        .get("fitness/v1/member/" + this.addData.member_id)
        .then(response => {
          this.detailMember = response.data.data;
          this.fullNameDetail =
            response.data.data.first_name + " " + response.data.data.last_name;
          // console.log('test', response)
        })
        .catch(error => {
          console.log("error", error);
        });

      axios
        .get(
          "transaction/v1/member_voucher?page=1&limit=20&member_id=" + this.addData.member_id
        )
        .then(response => {
          this.itemVouchers2 = response.data.data.rows
          this.itemVouchers = [];
          this.itemVouchers.push({ value: null, text: "Please select" })
          for (let i = 0; i < response.data.data.rows.length; i++) {
            const el = response.data.data.rows[i];
            this.itemVouchers.push({ value: `${el.voucher_id}`, text: `${el.voucher_no} @Rp.${el.voucher_amount}` })
          }
        })
        .catch(error => {
          console.log("error", error);
        });
    },
  },
  created() {
    this.fetchData();
  }
};
</script>

<style></style>
